import { FC, useCallback, useEffect, useState } from 'react';

import { appConfig } from '../app/app-config';
import { getTheme } from '../utils/get-theme';
import { useGetZendeskWidgetToken } from '../hooks/use-get-zendesk-widget-token';

export const ZendeskLiveChat: FC = () => {
    const { isHosTheme } = getTheme();
    const [isWidgetLoggedIn, setIsLoggedIn] = useState(false);
    const { data: token, isFetching } = useGetZendeskWidgetToken();
    const hideWidget = useCallback(() => {
        if (typeof window.zE !== 'function') return;

        window.zE('messenger', 'hide');
        window.zE('messenger', 'logoutUser', () => {
            setIsLoggedIn(false);
        });
    }, []);

    useEffect(() => {
        const scriptId = 'ze-snippet';
        const scriptExists = document.getElementById(scriptId);

        if (scriptExists) return hideWidget;

        const script = document.createElement('script');

        script.id = scriptId;
        script.src = isHosTheme
            ? appConfig.zendeskLiveChatSrc.hos
            : appConfig.zendeskLiveChatSrc.vs;
        script.async = true;

        document.body.append(script);

        return hideWidget;
    }, []);

    if (typeof window.zE !== 'function') return null;
    window.zE('messenger', isFetching ? 'hide' : 'show');

    if (isFetching) {
        return null;
    }

    if (!isWidgetLoggedIn && token) {
        window.zE(
            'messenger',
            'loginUser',
            (callback: (jwt: string | null) => unknown) => callback(token ?? null),
            (err: unknown) => {
                if (err) {
                    return;
                }

                setIsLoggedIn(true);
            }
        );
    }

    return null;
};
